/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type UpdateOrderStatusDtoStatus = typeof UpdateOrderStatusDtoStatus[keyof typeof UpdateOrderStatusDtoStatus];


export const UpdateOrderStatusDtoStatus = {
  created: 'created',
  confirmed: 'confirmed',
  preparing: 'preparing',
  shipped: 'shipped',
  completed: 'completed',
  canceled: 'canceled',
} as const;
